import moment from 'moment';
export const localtimeiso = (date)=>{
    const dateis = new moment(date).format('YYYY-MM-DD HH:mm:ss.000')
    return dateis.substr(0, 10) + 'T' + dateis.substr(11)+'Z';
}